import { render } from "./UserVerify.vue?vue&type=template&id=e05705c2"
import script from "./UserVerify.vue?vue&type=script&lang=js"
export * from "./UserVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__